import { render, staticRenderFns } from "./MerchantBaseInfo.vue?vue&type=template&id=49f8f1bc&scoped=true"
import script from "./MerchantBaseInfo.vue?vue&type=script&lang=js"
export * from "./MerchantBaseInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f8f1bc",
  null
  
)

component.options.__file = "MerchantBaseInfo.vue"
export default component.exports